import { getHotjarSettingsValues } from "@faire/help-center-utils/serialized-data/getHotjarSettingsValues";
import {
  getUserToken,
  getUserType,
} from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingRecordSessionInHotjar } from "@faire/help-center-utils/settings/getSettingRecordSessionInHotjar";
import { Hotjar } from "@faire/web--source/common/hotjar/hotjar";
import { filterAndProcessHotjarSettings } from "@faire/web--source/common/hotjar/hotjarUtils";
import { trackHotjarConfigHotjarSettingConfigLimitExceededError } from "@faire/web-api--source/events/hotjarConfig/error/hotjarSettingConfigLimitExceeded";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";

const HOTJAR_CONFIG_MAX_SETTINGS = 80;

const HOTJAR_ID = 3231906;
const HOTJAR_SNIPPET_VERSION = 6;

export async function initializeHotjar() {
  const shouldRecordSessionInHotjar = getSettingRecordSessionInHotjar();
  if (shouldRecordSessionInHotjar) {
    Hotjar.initialize(HOTJAR_ID, HOTJAR_SNIPPET_VERSION);

    const userToken = getUserToken();
    const userType = getUserType();
    const processedSettings = filterAndProcessHotjarSettings(
      getHotjarSettingsValues(),
      HOTJAR_CONFIG_MAX_SETTINGS
    );

    if (userToken && userType !== IUser.Type.ADMIN) {
      if (
        Object.values(getHotjarSettingsValues()).length >
        HOTJAR_CONFIG_MAX_SETTINGS
      ) {
        trackHotjarConfigHotjarSettingConfigLimitExceededError("help-center");
      }
      Hotjar.identify(userToken, processedSettings);
    }
  }
}
